import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import AdminLayout from '../../components/AdminLayout';
import { useAuth } from '../../context/AuthContext';
import api from '../../api';

const GOLD = '#D4AF37';
const GREEN = '#10b981';
const BG_CARD = '#0a0f1e';
const BORDER = 'rgba(255,255,255,0.06)';
const TEXT_SEC = '#6b7280';

function formatTime(t) {
  if (!t) return '';
  const [h, m] = t.split(':').map(Number);
  return `${h % 12 || 12}:${String(m).padStart(2, '0')} ${h >= 12 ? 'PM' : 'AM'}`;
}

function getGreeting() {
  const h = new Date().getHours();
  if (h < 12) return 'Good morning';
  if (h < 17) return 'Good afternoon';
  return 'Good evening';
}

function StatCard({ icon, label, value, color, sub }) {
  return (
    <div style={{
      background: BG_CARD,
      border: `1px solid ${BORDER}`,
      borderRadius: 16,
      padding: '22px 20px',
      display: 'flex',
      flexDirection: 'column',
      gap: 6,
      minWidth: 0,
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
        <span style={{ fontSize: 18, opacity: 0.7 }}>{icon}</span>
        <span style={{ fontSize: 12, fontWeight: 600, color: TEXT_SEC, textTransform: 'uppercase', letterSpacing: '0.06em' }}>{label}</span>
      </div>
      <div style={{ fontSize: 28, fontWeight: 800, color: color || '#fff', lineHeight: 1, letterSpacing: '-0.02em' }}>{value}</div>
      {sub && <div style={{ fontSize: 12, color: TEXT_SEC, marginTop: 2 }}>{sub}</div>}
    </div>
  );
}

function CancelModal({ appt, onConfirm, onClose }) {
  const [charge, setCharge] = useState(false);
  const price = parseFloat(appt.final_price || appt.service_price || 0);
  const chargeAmount = (price * 0.5).toFixed(2);

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 9999,
      background: 'rgba(0,0,0,0.75)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: '20px',
      touchAction: 'manipulation',
    }}>
      <div style={{
        background: '#0a0f1e',
        border: '1px solid rgba(255,255,255,0.1)',
        borderRadius: 20,
        padding: '28px 24px',
        width: '100%',
        maxWidth: 380,
      }}>
        <div style={{ fontSize: 32, marginBottom: 12, textAlign: 'center', color: '#f59e0b' }}>!</div>
        <h3 style={{ fontSize: 18, fontWeight: 800, color: '#fff', margin: '0 0 6px', textAlign: 'center' }}>Cancel Appointment?</h3>
        <p style={{ color: '#6b7280', fontSize: 13, textAlign: 'center', margin: '0 0 24px' }}>
          {appt.client_name} — {appt.service_name}
        </p>

        {/* Charge toggle */}
        <div style={{
          background: 'rgba(255,255,255,0.04)',
          border: `1px solid ${charge ? 'rgba(239,68,68,0.3)' : 'rgba(255,255,255,0.08)'}`,
          borderRadius: 12,
          padding: '16px',
          marginBottom: 20,
          cursor: 'pointer',
          touchAction: 'manipulation',
        }} onClick={() => setCharge(!charge)}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <div>
              <div style={{ fontSize: 14, fontWeight: 700, color: charge ? '#ef4444' : '#fff' }}>
                Charge cancellation fee
              </div>
              <div style={{ fontSize: 12, color: '#6b7280', marginTop: 3 }}>
                50% of service = ${chargeAmount}
              </div>
            </div>
            <div style={{
              width: 44, height: 24, borderRadius: 12,
              background: charge ? '#ef4444' : 'rgba(255,255,255,0.1)',
              position: 'relative',
              transition: 'background 0.2s',
              flexShrink: 0,
            }}>
              <div style={{
                position: 'absolute',
                top: 2, left: charge ? 22 : 2,
                width: 20, height: 20,
                borderRadius: '50%',
                background: '#fff',
                transition: 'left 0.2s',
              }} />
            </div>
          </div>
        </div>

        <div style={{ display: 'flex', gap: 10 }}>
          <button onClick={onClose} style={{
            flex: 1, padding: '14px', borderRadius: 10,
            background: 'rgba(255,255,255,0.04)',
            border: '1px solid rgba(255,255,255,0.08)',
            color: '#fff', fontSize: 14, fontWeight: 600,
            cursor: 'pointer', touchAction: 'manipulation',
          }}>
            Keep It
          </button>
          <button onClick={() => onConfirm(charge)} style={{
            flex: 1, padding: '14px', borderRadius: 10,
            background: charge ? '#ef4444' : 'rgba(239,68,68,0.15)',
            border: `1px solid ${charge ? '#ef4444' : 'rgba(239,68,68,0.2)'}`,
            color: '#fff', fontSize: 14, fontWeight: 700,
            cursor: 'pointer', touchAction: 'manipulation',
          }}>
            {charge ? `Cancel & Charge $${chargeAmount}` : 'Cancel (No Charge)'}
          </button>
        </div>
      </div>
    </div>
  );
}

function EditModal({ appt, services, onSave, onClose }) {
  const todayISO = new Date().toISOString().split('T')[0];
  const [date, setDate] = useState(appt.appointment_date || todayISO);
  const [time, setTime] = useState(appt.start_time ? appt.start_time.slice(0, 5) : '09:00');
  const [serviceId, setServiceId] = useState(appt.service_id || '');
  const [saving, setSaving] = useState(false);

  const timeSlots = [];
  for (let h = 8; h <= 23; h++) {
    for (let m = 0; m < 60; m += 30) {
      if (h === 23 && m > 0) break;
      const val = `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
      const label = `${h % 12 || 12}:${String(m).padStart(2, '0')} ${h >= 12 ? 'PM' : 'AM'}`;
      timeSlots.push({ val, label });
    }
  }

  const handleSave = async () => {
    setSaving(true);
    try {
      await onSave(appt.id, { appointment_date: date, start_time: time, service_id: serviceId });
      onClose();
    } finally {
      setSaving(false);
    }
  };

  const inputStyle = {
    width: '100%',
    padding: '12px 14px',
    fontSize: 14,
    background: 'rgba(255,255,255,0.04)',
    border: '1px solid rgba(255,255,255,0.1)',
    borderRadius: 8,
    color: '#fff',
    outline: 'none',
    boxSizing: 'border-box',
    appearance: 'none',
    WebkitAppearance: 'none',
  };

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 9999,
      background: 'rgba(0,0,0,0.75)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: '20px',
      touchAction: 'manipulation',
    }}>
      <div style={{
        background: '#0a0f1e',
        border: '1px solid rgba(255,255,255,0.1)',
        borderRadius: 20,
        padding: '28px 24px',
        width: '100%',
        maxWidth: 380,
      }}>
        <h3 style={{ fontSize: 18, fontWeight: 800, color: '#fff', margin: '0 0 6px', textAlign: 'center' }}>Edit Appointment</h3>
        <p style={{ color: '#6b7280', fontSize: 13, textAlign: 'center', margin: '0 0 24px' }}>
          {appt.client_name} — {appt.service_name}
        </p>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 14, marginBottom: 24 }}>
          <div>
            <label style={{ fontSize: 12, fontWeight: 600, color: TEXT_SEC, marginBottom: 6, display: 'block', textTransform: 'uppercase', letterSpacing: '0.04em' }}>Date</label>
            <input type="date" value={date} min={todayISO} onChange={e => setDate(e.target.value)} style={inputStyle} />
          </div>
          <div>
            <label style={{ fontSize: 12, fontWeight: 600, color: TEXT_SEC, marginBottom: 6, display: 'block', textTransform: 'uppercase', letterSpacing: '0.04em' }}>Time</label>
            <select value={time} onChange={e => setTime(e.target.value)} style={inputStyle}>
              {timeSlots.map(s => <option key={s.val} value={s.val} style={{ background: '#0a0f1e' }}>{s.label}</option>)}
            </select>
          </div>
          <div>
            <label style={{ fontSize: 12, fontWeight: 600, color: TEXT_SEC, marginBottom: 6, display: 'block', textTransform: 'uppercase', letterSpacing: '0.04em' }}>Service</label>
            <select value={serviceId} onChange={e => setServiceId(e.target.value)} style={inputStyle}>
              <option value="" style={{ background: '#0a0f1e' }}>Select a service</option>
              {services.map(s => <option key={s.id} value={s.id} style={{ background: '#0a0f1e' }}>{s.name}</option>)}
            </select>
          </div>
        </div>

        <div style={{ display: 'flex', gap: 10 }}>
          <button onClick={onClose} style={{
            flex: 1, padding: '14px', borderRadius: 10,
            background: 'rgba(255,255,255,0.04)',
            border: '1px solid rgba(255,255,255,0.08)',
            color: '#fff', fontSize: 14, fontWeight: 600,
            cursor: 'pointer', touchAction: 'manipulation',
          }}>
            Cancel
          </button>
          <button disabled={saving || !serviceId} onClick={handleSave} style={{
            flex: 1, padding: '14px', borderRadius: 10,
            background: saving ? 'rgba(59,130,246,0.3)' : '#3b82f6',
            border: '1px solid #3b82f6',
            color: '#fff', fontSize: 14, fontWeight: 700,
            cursor: saving || !serviceId ? 'not-allowed' : 'pointer',
            opacity: saving || !serviceId ? 0.5 : 1,
            touchAction: 'manipulation',
          }}>
            {saving ? 'Saving...' : 'Save Changes'}
          </button>
        </div>
      </div>
    </div>
  );
}

function BlockTimeModal({ onSave, onClose }) {
  const todayISO = new Date().toISOString().split('T')[0];
  const [date, setDate] = useState(todayISO);
  const [startTime, setStartTime] = useState('12:00');
  const [endTime, setEndTime] = useState('13:00');
  const [reason, setReason] = useState('');
  const [saving, setSaving] = useState(false);

  const timeSlots = [];
  for (let h = 8; h <= 23; h++) {
    for (let m = 0; m < 60; m += 30) {
      if (h === 23 && m > 0) break;
      const val = `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
      const label = `${h % 12 || 12}:${String(m).padStart(2, '0')} ${h >= 12 ? 'PM' : 'AM'}`;
      timeSlots.push({ val, label });
    }
  }

  const handleSave = async () => {
    if (endTime <= startTime) return;
    setSaving(true);
    try {
      await onSave({ date, start_time: startTime, end_time: endTime, reason: reason || undefined });
      onClose();
    } finally {
      setSaving(false);
    }
  };

  const inputStyle = {
    width: '100%',
    padding: '12px 14px',
    fontSize: 14,
    background: 'rgba(255,255,255,0.04)',
    border: '1px solid rgba(255,255,255,0.1)',
    borderRadius: 8,
    color: '#fff',
    outline: 'none',
    boxSizing: 'border-box',
    appearance: 'none',
    WebkitAppearance: 'none',
  };

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 9999,
      background: 'rgba(0,0,0,0.75)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: '20px',
      touchAction: 'manipulation',
    }}>
      <div style={{
        background: '#0a0f1e',
        border: '1px solid rgba(255,255,255,0.1)',
        borderRadius: 20,
        padding: '28px 24px',
        width: '100%',
        maxWidth: 380,
      }}>
        <h3 style={{ fontSize: 18, fontWeight: 800, color: '#fff', margin: '0 0 20px', textAlign: 'center' }}>Block Time</h3>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 14, marginBottom: 24 }}>
          <div>
            <label style={{ fontSize: 12, fontWeight: 600, color: TEXT_SEC, marginBottom: 6, display: 'block', textTransform: 'uppercase', letterSpacing: '0.04em' }}>Date</label>
            <input type="date" value={date} min={todayISO} onChange={e => setDate(e.target.value)} style={inputStyle} />
          </div>
          <div>
            <label style={{ fontSize: 12, fontWeight: 600, color: TEXT_SEC, marginBottom: 6, display: 'block', textTransform: 'uppercase', letterSpacing: '0.04em' }}>Start Time</label>
            <select value={startTime} onChange={e => setStartTime(e.target.value)} style={inputStyle}>
              {timeSlots.map(s => <option key={s.val} value={s.val} style={{ background: '#0a0f1e' }}>{s.label}</option>)}
            </select>
          </div>
          <div>
            <label style={{ fontSize: 12, fontWeight: 600, color: TEXT_SEC, marginBottom: 6, display: 'block', textTransform: 'uppercase', letterSpacing: '0.04em' }}>End Time</label>
            <select value={endTime} onChange={e => setEndTime(e.target.value)} style={inputStyle}>
              {timeSlots.map(s => <option key={s.val} value={s.val} style={{ background: '#0a0f1e' }}>{s.label}</option>)}
            </select>
            {endTime <= startTime && <div style={{ fontSize: 12, color: '#ef4444', marginTop: 4 }}>End time must be after start time</div>}
          </div>
          <div>
            <label style={{ fontSize: 12, fontWeight: 600, color: TEXT_SEC, marginBottom: 6, display: 'block', textTransform: 'uppercase', letterSpacing: '0.04em' }}>Reason (optional)</label>
            <input type="text" value={reason} onChange={e => setReason(e.target.value)} placeholder="Lunch, Personal, Closed..." style={inputStyle} />
          </div>
        </div>

        <div style={{ display: 'flex', gap: 10 }}>
          <button onClick={onClose} style={{
            flex: 1, padding: '14px', borderRadius: 10,
            background: 'rgba(255,255,255,0.04)',
            border: '1px solid rgba(255,255,255,0.08)',
            color: '#fff', fontSize: 14, fontWeight: 600,
            cursor: 'pointer', touchAction: 'manipulation',
          }}>
            Cancel
          </button>
          <button disabled={saving || endTime <= startTime} onClick={handleSave} style={{
            flex: 1, padding: '14px', borderRadius: 10,
            background: saving ? 'rgba(239,68,68,0.3)' : '#ef4444',
            border: '1px solid #ef4444',
            color: '#fff', fontSize: 14, fontWeight: 700,
            cursor: saving || endTime <= startTime ? 'not-allowed' : 'pointer',
            opacity: saving || endTime <= startTime ? 0.5 : 1,
            touchAction: 'manipulation',
          }}>
            {saving ? 'Blocking...' : 'Block This Time'}
          </button>
        </div>
      </div>
    </div>
  );
}

function BlockedCard({ appt, onUnblock }) {
  const [acting, setActing] = useState(false);

  return (
    <div style={{
      background: BG_CARD,
      border: `1px solid ${BORDER}`,
      borderLeft: '3px solid #6b7280',
      borderRadius: 16,
      padding: '18px 20px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      gap: 12,
    }}>
      <div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
          <span style={{
            fontSize: 10, fontWeight: 700, color: '#ef4444',
            background: 'rgba(239,68,68,0.12)',
            padding: '2px 8px', borderRadius: 6,
            textTransform: 'uppercase', letterSpacing: '0.04em',
          }}>BLOCKED</span>
        </div>
        <div style={{ fontWeight: 600, fontSize: 14, color: '#fff' }}>
          {formatTime(appt.start_time)} — {formatTime(appt.end_time)}
        </div>
        {appt.notes && <div style={{ color: TEXT_SEC, fontSize: 12, marginTop: 4 }}>{appt.notes}</div>}
      </div>
      <button
        disabled={acting}
        onClick={async () => {
          setActing(true);
          try { await onUnblock(appt.id); } finally { setActing(false); }
        }}
        style={{
          padding: '8px 16px',
          fontSize: 12,
          fontWeight: 600,
          background: 'rgba(255,255,255,0.04)',
          color: '#6b7280',
          border: '1px solid rgba(255,255,255,0.08)',
          borderRadius: 8,
          cursor: acting ? 'not-allowed' : 'pointer',
          opacity: acting ? 0.5 : 1,
          touchAction: 'manipulation',
          flexShrink: 0,
        }}
      >
        Unblock
      </button>
    </div>
  );
}

function AppointmentCard({ appt, onApprove, onDecline, onCancel, onEdit, services }) {
  const [msg, setMsg] = useState('');
  const [acting, setActing] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const isPending = appt.status === 'pending';
  const isCompleted = appt.status === 'completed';

  const borderColor = isPending ? '#f59e0b' : isCompleted ? TEXT_SEC : GREEN;

  const handle = async (action) => {
    setActing(true);
    try { await action(appt.id, msg); } finally { setActing(false); }
  };

  return (
    <div style={{
      background: BG_CARD,
      border: `1px solid ${BORDER}`,
      borderLeft: `3px solid ${borderColor}`,
      borderRadius: 16,
      padding: '18px 20px',
      display: 'flex',
      flexDirection: 'column',
      gap: 12,
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 12, flexWrap: 'wrap' }}>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
            <span style={{ fontWeight: 700, fontSize: 15, color: '#fff' }}>{formatTime(appt.start_time)}</span>
            <span style={{ width: 4, height: 4, borderRadius: '50%', background: TEXT_SEC, flexShrink: 0 }} />
            <span style={{ fontWeight: 600, fontSize: 15, color: '#fff' }}>{appt.client_name}</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 6, flexWrap: 'wrap' }}>
            <span style={{ fontSize: 13, color: GOLD, fontWeight: 600 }}>{appt.service_name}</span>
            {appt.is_after_hours && (
              <span style={{ fontSize: 10, fontWeight: 700, color: '#f59e0b', background: 'rgba(245,158,11,0.1)', padding: '2px 8px', borderRadius: 6, textTransform: 'uppercase', letterSpacing: '0.04em' }}>After Hours</span>
            )}
            {appt.is_mobile && (
              <span style={{ fontSize: 10, fontWeight: 600, color: TEXT_SEC, background: 'rgba(255,255,255,0.04)', padding: '2px 8px', borderRadius: 6 }}>Mobile</span>
            )}
          </div>
          {appt.notes && <div style={{ color: TEXT_SEC, fontSize: 12, marginTop: 6 }}>{appt.notes}</div>}
        </div>
        <div style={{ textAlign: 'right', flexShrink: 0 }}>
          <div style={{ color: GOLD, fontWeight: 800, fontSize: 20, letterSpacing: '-0.02em' }}>
            ${parseFloat(appt.final_price || appt.service_price || 0).toFixed(0)}
          </div>
        </div>
      </div>

      {isPending && (
        <div style={{ display: 'flex', gap: 8, alignItems: 'stretch', flexWrap: 'wrap' }}>
          <input
            style={{
              flex: '1 1 100%',
              minWidth: 120,
              fontSize: 14,
              padding: '12px 14px',
              minHeight: 48,
              background: 'rgba(255,255,255,0.04)',
              border: `1px solid ${BORDER}`,
              borderRadius: 8,
              color: '#fff',
              outline: 'none',
              touchAction: 'manipulation',
              boxSizing: 'border-box',
            }}
            placeholder="Add a note..."
            value={msg}
            onChange={e => setMsg(e.target.value)}
          />
          <button
            disabled={acting}
            onClick={() => handle(onApprove)}
            style={{
              padding: '12px 20px',
              minHeight: 48,
              fontSize: 14,
              fontWeight: 700,
              background: GREEN,
              color: '#fff',
              border: 'none',
              borderRadius: 8,
              cursor: acting ? 'not-allowed' : 'pointer',
              opacity: acting ? 0.5 : 1,
              transition: 'opacity 0.15s',
              touchAction: 'manipulation',
              WebkitTapHighlightColor: 'transparent',
              flex: '1 1 0',
            }}
          >
            Approve
          </button>
          <button
            disabled={acting}
            onClick={() => handle(onDecline)}
            style={{
              padding: '12px 20px',
              minHeight: 48,
              fontSize: 14,
              fontWeight: 700,
              background: 'rgba(239,68,68,0.15)',
              color: '#ef4444',
              border: '1px solid rgba(239,68,68,0.2)',
              borderRadius: 8,
              cursor: acting ? 'not-allowed' : 'pointer',
              opacity: acting ? 0.5 : 1,
              transition: 'opacity 0.15s',
              touchAction: 'manipulation',
              WebkitTapHighlightColor: 'transparent',
              flex: '1 1 0',
            }}
          >
            Decline
          </button>
        </div>
      )}

      {!isPending && !isCompleted && appt.status !== 'cancelled' && (
        <div style={{ display: 'flex', gap: 8 }}>
          {onEdit && (
            <button
              disabled={acting}
              onClick={() => setShowEditModal(true)}
              style={{
                padding: '10px 20px',
                minHeight: 44,
                fontSize: 13,
                fontWeight: 600,
                background: 'rgba(59,130,246,0.08)',
                color: '#3b82f6',
                border: '1px solid rgba(59,130,246,0.2)',
                borderRadius: 8,
                cursor: acting ? 'not-allowed' : 'pointer',
                opacity: acting ? 0.5 : 1,
                touchAction: 'manipulation',
                WebkitTapHighlightColor: 'transparent',
              }}
            >
              Edit
            </button>
          )}
          {onCancel && (
            <button
              disabled={acting}
              onClick={() => setShowCancelModal(true)}
              style={{
                padding: '10px 20px',
                minHeight: 44,
                fontSize: 13,
                fontWeight: 600,
                background: 'rgba(239,68,68,0.08)',
                color: '#ef4444',
                border: '1px solid rgba(239,68,68,0.2)',
                borderRadius: 8,
                cursor: acting ? 'not-allowed' : 'pointer',
                opacity: acting ? 0.5 : 1,
                touchAction: 'manipulation',
                WebkitTapHighlightColor: 'transparent',
              }}
            >
              Cancel Appointment
            </button>
          )}
        </div>
      )}

      {/* Also show Edit for pending appointments */}
      {isPending && onEdit && (
        <div style={{ display: 'flex', gap: 8, marginTop: -4 }}>
          <button
            disabled={acting}
            onClick={() => setShowEditModal(true)}
            style={{
              padding: '10px 20px',
              minHeight: 44,
              fontSize: 13,
              fontWeight: 600,
              background: 'rgba(59,130,246,0.08)',
              color: '#3b82f6',
              border: '1px solid rgba(59,130,246,0.2)',
              borderRadius: 8,
              cursor: acting ? 'not-allowed' : 'pointer',
              opacity: acting ? 0.5 : 1,
              touchAction: 'manipulation',
              WebkitTapHighlightColor: 'transparent',
            }}
          >
            Edit
          </button>
        </div>
      )}

      {showCancelModal && (
        <CancelModal
          appt={appt}
          onClose={() => setShowCancelModal(false)}
          onConfirm={(charge) => {
            setShowCancelModal(false);
            setActing(true);
            onCancel(appt.id, charge).finally(() => setActing(false));
          }}
        />
      )}

      {showEditModal && (
        <EditModal
          appt={appt}
          services={services}
          onClose={() => setShowEditModal(false)}
          onSave={onEdit}
        />
      )}
    </div>
  );
}

function QuickAction({ icon, label, to }) {
  return (
    <Link to={to} style={{
      display: 'flex',
      alignItems: 'center',
      gap: 10,
      padding: '14px 18px',
      minHeight: 48,
      background: BG_CARD,
      border: `1px solid ${BORDER}`,
      borderRadius: 8,
      color: '#fff',
      textDecoration: 'none',
      fontSize: 14,
      fontWeight: 600,
      transition: 'background 0.15s, border-color 0.15s',
      whiteSpace: 'nowrap',
      cursor: 'pointer',
      touchAction: 'manipulation',
      WebkitTapHighlightColor: 'transparent',
    }}>
      <span style={{ fontSize: 16, opacity: 0.7 }}>{icon}</span>
      {label}
    </Link>
  );
}

function ClientRow({ client }) {
  const initials = (client.client_name || '?').split(' ').map(w => w[0]).join('').toUpperCase().slice(0, 2);
  const dateStr = client.appointment_date
    ? new Date(client.appointment_date + 'T00:00:00').toLocaleDateString('en-US', { month: 'short', day: 'numeric' })
    : '';

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      gap: 14,
      padding: '12px 0',
      borderBottom: `1px solid ${BORDER}`,
    }}>
      <div style={{
        width: 38,
        height: 38,
        borderRadius: '50%',
        background: 'rgba(212,175,55,0.12)',
        color: GOLD,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: 13,
        fontWeight: 700,
        flexShrink: 0,
        letterSpacing: '0.02em',
      }}>
        {initials}
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontWeight: 600, fontSize: 14, color: '#fff' }}>{client.client_name}</div>
        <div style={{ fontSize: 12, color: TEXT_SEC, marginTop: 2 }}>{client.service_name}</div>
      </div>
      <div style={{ fontSize: 12, color: TEXT_SEC, flexShrink: 0 }}>{dateStr}</div>
    </div>
  );
}

export default function Dashboard() {
  const [showCalendar, setShowCalendar] = useState(true);
  const [pending, setPending] = useState([]);
  const [upcoming, setUpcoming] = useState([]);
  const [analytics, setAnalytics] = useState(null);
  const [profCount, setProfCount] = useState(null);
  const [recentSms, setRecentSms] = useState([]);
  const [finance, setFinance] = useState(null);
  const [services, setServices] = useState([]);
  const [blocked, setBlocked] = useState([]);
  const [showBlockModal, setShowBlockModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const { username } = useAuth();

  const loadData = () => {
    setLoading(true);
    Promise.all([
      api.get('/appointments/pending'),
      api.get('/appointments/upcoming'),
      api.get('/appointments/analytics'),
      api.get('/barbers/count').catch(() => ({ data: { count: '—' } })),
      api.get('/crm/followup/recent-sms').catch(() => ({ data: [] })),
      api.get('/finance/summary').catch(() => ({ data: null })),
      api.get('/services').catch(() => ({ data: [] })),
      api.get('/appointments', { params: { status: 'blocked' } }).catch(() => ({ data: [] })),
    ]).then(([p, up, an, prof, sms, fin, svc, blk]) => {
      setPending(p.data);
      setUpcoming(up.data);
      setAnalytics(an.data);
      setProfCount(prof.data.count);
      setRecentSms(sms.data);
      setFinance(fin.data);
      setServices(Array.isArray(svc.data) ? svc.data : []);
      setBlocked(Array.isArray(blk.data) ? blk.data : []);
    }).finally(() => setLoading(false));
  };

  useEffect(() => { loadData(); }, []);

  const handleApprove = async (id, message) => {
    await api.put(`/appointments/${id}/approve`, { admin_message: message });
    loadData();
  };

  const handleDecline = async (id, message) => {
    await api.put(`/appointments/${id}/decline`, { admin_message: message });
    loadData();
  };

  const handleCancel = async (id, charge) => {
    await api.put(`/appointments/${id}/cancel`, { forceCharge: charge });
    loadData();
  };

  const handleEdit = async (id, data) => {
    await api.put(`/appointments/${id}`, data);
    loadData();
  };

  const handleBlockTime = async (data) => {
    await api.post('/appointments/block', data);
    loadData();
  };

  const handleUnblock = async (id) => {
    await api.delete(`/appointments/${id}`);
    loadData();
  };

  const fmt = (n) => `$${parseFloat(n || 0).toLocaleString('en-US', { maximumFractionDigits: 0 })}`;
  const todayStr = new Date().toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' });
  const displayName = username ? username.charAt(0).toUpperCase() + username.slice(1) : 'there';

  const allAppointments = [...pending.map(a => ({ ...a, status: 'pending' })), ...upcoming.map(a => ({ ...a, status: a.status || 'confirmed' }))];
  const todayDate = new Date().toISOString().split('T')[0];
  const todayAppointments = allAppointments.filter(a => a.appointment_date === todayDate);
  const totalTodaySlots = 8;
  const filledSlots = todayAppointments.length;

  const recentClients = [...pending, ...upcoming]
    .sort((a, b) => (b.created_at || b.appointment_date || '').localeCompare(a.created_at || a.appointment_date || ''))
    .slice(0, 5);

  return (
    <AdminLayout>
      <div style={{ maxWidth: 800, margin: '0 auto' }}>
        {/* Top Bar */}
        <div style={{
          position: 'sticky',
          top: 0,
          zIndex: 10,
          background: '#050810',
          paddingTop: 8,
          paddingBottom: 16,
          marginBottom: 8,
          pointerEvents: 'none',
        }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pointerEvents: 'auto' }}>
            <div>
              <h1 style={{ fontSize: 22, fontWeight: 800, color: '#fff', margin: 0, lineHeight: 1.3 }}>
                {getGreeting()}, {displayName}
              </h1>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginTop: 4 }}>
                <span style={{ fontSize: 13, color: TEXT_SEC }}>{todayStr}</span>
              </div>
            </div>
            <Link to="/dash/appointments" style={{
              width: 48,
              height: 48,
              borderRadius: '50%',
              background: BG_CARD,
              border: `1px solid ${BORDER}`,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              textDecoration: 'none',
              fontSize: 18,
              position: 'relative',
              touchAction: 'manipulation',
              WebkitTapHighlightColor: 'transparent',
            }}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>
              {pending.length > 0 && (
                <span style={{
                  position: 'absolute',
                  top: -2,
                  right: -2,
                  width: 18,
                  height: 18,
                  borderRadius: '50%',
                  background: '#ef4444',
                  color: '#fff',
                  fontSize: 10,
                  fontWeight: 800,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}>
                  {pending.length}
                </span>
              )}
            </Link>
          </div>
        </div>



        {/* Upcoming Appointments */}
        <div style={{ marginBottom: 28 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: showCalendar ? 14 : 0 }}>
            <h2 style={{ fontSize: 16, fontWeight: 700, color: '#fff', margin: 0 }}>
              Upcoming Appointments
              {pending.length > 0 && (
                <span style={{
                  marginLeft: 10,
                  fontSize: 11,
                  fontWeight: 700,
                  background: 'rgba(245,158,11,0.15)',
                  color: '#f59e0b',
                  padding: '3px 10px',
                  borderRadius: 20,
                }}>
                  {pending.length} pending
                </span>
              )}
            </h2>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              <button onClick={() => setShowCalendar(v => !v)} style={{
                background: 'transparent',
                border: `1px solid ${BORDER}`,
                borderRadius: 8,
                color: '#6b7280',
                fontSize: 18,
                width: 34,
                height: 34,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                touchAction: 'manipulation',
                WebkitTapHighlightColor: 'transparent',
                transition: 'transform 0.2s',
                transform: showCalendar ? 'rotate(0deg)' : 'rotate(180deg)',
              }}>
                ⌄
              </button>
              <Link to="/dash/appointments" style={{ fontSize: 12, color: GOLD, textDecoration: 'none', fontWeight: 600, padding: '10px 4px', touchAction: 'manipulation', WebkitTapHighlightColor: 'transparent' }}>View all →</Link>
            </div>
          </div>

          {showCalendar && (
            loading ? (
              <div style={{ textAlign: 'center', padding: 48 }}><div className="spinner" style={{ margin: '0 auto' }} /></div>
            ) : allAppointments.length === 0 ? (
              <div style={{
                background: BG_CARD,
                border: `1px solid ${BORDER}`,
                borderRadius: 16,
                padding: '48px 24px',
                textAlign: 'center',
              }}>
                <div style={{ fontSize: 40, marginBottom: 12, color: TEXT_SEC }}>—</div>
                <div style={{ fontWeight: 700, fontSize: 15, color: '#fff', marginBottom: 4 }}>No appointments today</div>
                <div style={{ fontSize: 13, color: TEXT_SEC }}>Enjoy the downtime or share your booking link</div>
              </div>
            ) : (
              <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                {allAppointments.slice(0, 8).map(appt => (
                  <AppointmentCard
                    key={appt.id}
                    appt={appt}
                    onApprove={handleApprove}
                    onDecline={handleDecline}
                    onCancel={handleCancel}
                    onEdit={handleEdit}
                    services={services}
                  />
                ))}
              </div>
            )
          )}
        </div>


      </div>


    </AdminLayout>
  );
}
